import React, { useState, useRef, useEffect } from 'react';
import { DayPicker } from 'react-day-picker';
import { format } from 'date-fns';
import 'react-day-picker/dist/style.css';
import { FaCalendarAlt } from 'react-icons/fa';


const CalendarPopup = ({ selectedRange, setSelectedRange }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const windowWidth = window.innerWidth;
  const ref = useRef();

  const handleDateSelect = (range) => {
    setSelectedRange(range);
    if (range?.from && range?.to) {
      setShowCalendar(false); // close popup on full selection
    }
  };

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setShowCalendar(false);
    }
  };



  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div id='customCalender' ref={ref} className={`relative CustomCalenderPopup ${windowWidth < 768 ? 'mobileCalender' : ""}`} >
      <div
        className="flex items-center gap-3 cursor-pointer dateInputWrapper"
        onClick={() => setShowCalendar(!showCalendar)}
      >
        <input
          type="text"
          readOnly
          placeholder="From Date"
          value={selectedRange?.from ? format(selectedRange.from, 'dd/MM/yyyy') : ''}
          className="form-control"
        />
        <FaCalendarAlt className="calenderIcon" />
        <input
          type="text"
          readOnly
          placeholder="To Date"
          value={selectedRange?.to ? format(selectedRange.to, 'dd/MM/yyyy') : ''}
          className="form-control"
        />
        <FaCalendarAlt className="calenderIcon" />
      </div>

      {(showCalendar || windowWidth < 768) && (
        <div className="absolute z-50  bg-white p-4 pt-3 rounded-xl shadow-xl calenderPopup">
          <DayPicker
            mode="range"
            selected={selectedRange}
            onSelect={handleDateSelect}
            defaultMonth={new Date()}
            weekStartsOn={1}
            disabled={{ after: new Date() }}
            modifiersClassNames={{
              selected: 'selected',
              range_start: 'range',
              range_end: 'range',
              today: 'today',
            }}
            classNames={{
              table: 'w-100 border-collapse',
              head_row: 'd-flex justify-content-between',
              head_cell: 'text-muted fw-bold flex-fill text-center ',
              row: 'd-flex',
              cell: 'flex-fill text-center  border  rdp-cell',
              day_selected: 'selected',
              day_today: 'today ',
              day_outside: 'text-muted',
              caption_label: 'fw-bold year',
            }}
          />
        </div>
      )}
    </div>
  );
};

const CalendarFilter = ({ t, handleDateFilter,handleFilter }) => {
  const [selectedRange, setSelectedRange] = useState({ from: undefined, to: undefined });
  const windowWidth = window.innerWidth;
  const handleReset = () => {
    setSelectedRange('reset');
    handleFilter()
  };

  useEffect(() => {
    handleDateFilter(selectedRange)
  }, [selectedRange])

  return (
    <div className='dayPickerWrapper'>
      <CalendarPopup selectedRange={selectedRange} setSelectedRange={setSelectedRange} />


      <button className={`contact_filter_buttonstyle ${windowWidth < 768 ? 'mobileClear' : ""}`} onClick={handleReset}>
        {windowWidth > 768 && (<> <i className="fa-solid fa-filter-circle-xmark"></i>&nbsp;</>)}
        <span className="clearFilter">{t ? t('Clear_filters') : 'Clear filters'}</span>
      </button>

    </div>

  );
};

export default CalendarFilter;
